import { baseApi } from "./base";
import type { MsLoginInput, AuthState } from "../types";

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    loginMicrosoft: builder.mutation<AuthState, MsLoginInput>({
      query: ({ token }) => ({
        url: "/auth/azure",
        method: "POST",
        body: { token },
      }),
      invalidatesTags: ["Auth"],
    }),
    refreshToken: builder.mutation<{ token: string }, void>({
      query: () => ({
        url: "/auth/refresh",
        method: "POST",
      }),
    }),
  }),
});

export const { useLoginMicrosoftMutation, useRefreshTokenMutation } = authApi;
